import { PositionAssignmentsRepository } from '@src/main/modules/reports/positionassignments/domain/position-assignments.repository';
import {
  PositionAssignmentReport,
  PositionAssignmentRequest,
  PositionAssignmentResponse,
} from '@src/main/modules/reports/shared/domain/report.interface';
import { parsePositionAssignmentCriteria } from '@src/main/modules/reports/shared/infrastructure/mapper/position-assigments.mapper';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

const path = '/position_assignment';

export const createPositionAssignmentsHttpRepository = (
  tokenProvider: TokenProvider,
): PositionAssignmentsHttpRepository => new PositionAssignmentsHttpRepository(tokenProvider);

class PositionAssignmentsHttpRepository implements PositionAssignmentsRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) {
      throw new Error('Authentication token is missing');
    }
    return token;
  }

  async findByCriteria(
    criteria: PositionAssignmentRequest,
  ): Promise<PageResponse<PositionAssignmentReport>> {
    const token = await this.getAuthToken();
    const params = parsePositionAssignmentCriteria(criteria);

    const response = await api.get<PageResponse<PositionAssignmentResponse>>(
      `${path}/all`,
      token,
      params,
    );
    return {
      items: response.items.map((item) => ({
        id: item.id,
        flightNumber: item.flight_num,
        flightDate: item.flight_date,
        departureAirport: item.flight_departure,
        arrivalAirport: item.flight_arrival,
        aircraftRegistration: item.flight_mat,
      })),
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      total: response.total,
      first: response.first,
      last: response.last,
    };
  }

  async downloadPdf(evaluationId: string): Promise<Blob> {
    const token = await this.getAuthToken();
    return await api.fetchBlob(`${path}/${evaluationId}/pdf`, token);
  }
}
